import { render, staticRenderFns } from "./correct-rate-steps.vue?vue&type=template&id=8d96972a&scoped=true"
import script from "./correct-rate-steps.vue?vue&type=script&lang=js"
export * from "./correct-rate-steps.vue?vue&type=script&lang=js"
import style0 from "./correct-rate-steps.vue?vue&type=style&index=0&id=8d96972a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d96972a",
  null
  
)

export default component.exports